import { useOpenAutopilotUpgrade } from 'hooks/useOpenAutopilotUpgrade'
import { useCurrentWorkspace } from 'hooks/useCurrentWorkspace'
import { Button } from 'blaze-ui/Button'
import LockOpen3 from 'blaze-ui/icons/24/LockOpen3'

export const AutopilotUpgradeRemoveWatermarkButton = () => {
  const openVirtualMarketerPlansModal = useOpenAutopilotUpgrade()
  const workspace = useCurrentWorkspace()

  if (workspace?.is_ap_freemium) {
    return (
      <Button variant="tertiary" size="md" onPress={openVirtualMarketerPlansModal} frontIcon={LockOpen3} fullWidth>
        Remove Watermark
      </Button>
    )
  }

  return <></>
}
